/**
 * Business recognition date for a point in time. Mirrors
 * {@link App\Util\RecognitionDate}: before 06:00 Amsterdam the previous
 * calendar day is still the active recognition day.
 */
const BUSINESS_TIMEZONE = 'Europe/Amsterdam';
const CUTOFF_HOUR = 6;

export function recognitionDateForPointInTime(at: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: BUSINESS_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    hour12: false,
  }).formatToParts(at);

  const year = parts.find((p) => p.type === 'year')?.value ?? '1970';
  const month = parts.find((p) => p.type === 'month')?.value ?? '01';
  const day = parts.find((p) => p.type === 'day')?.value ?? '01';
  const hour = Number(parts.find((p) => p.type === 'hour')?.value ?? '0');

  if (hour > CUTOFF_HOUR - 1) {
    return `${year}-${month}-${day}`;
  }

  const previous = new Date(at.getTime() - 86_400_000);
  const prevParts = new Intl.DateTimeFormat('en-CA', {
    timeZone: BUSINESS_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(previous);

  const prevYear = prevParts.find((p) => p.type === 'year')?.value ?? year;
  const prevMonth = prevParts.find((p) => p.type === 'month')?.value ?? month;
  const prevDay = prevParts.find((p) => p.type === 'day')?.value ?? day;

  return `${prevYear}-${prevMonth}-${prevDay}`;
}

/** The recognition day of `at` as a local-midnight Date, for date-fns day math. */
export function recognitionDay(at: Date = new Date()): Date {
  const [y, m, d] = recognitionDateForPointInTime(at).split('-').map(Number);
  return new Date(y, m - 1, d);
}
